import { faDog, faCat, faHorse } from "@fortawesome/pro-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { PatientKind } from "common/types";
import Icon from "common/components/Icon";

import { Clinic } from "client/clinics/types";
import { BrowseAllPatientKind, IBrowseFilterSpeciesKind } from "client/products/types";
import InlineSelect from "client/common/components/inputs/InlineSelect";

import styles from "../styles/CatalogFilters.module.less";

type CatalogFiltersProps = {
  species: IBrowseFilterSpeciesKind;
  setSpecies: (species: IBrowseFilterSpeciesKind) => void;
  clinic: Clinic;
};

const CatalogFilters = ({ species, setSpecies, clinic }: CatalogFiltersProps) => {
  const clinicMetadata = clinic.clinic_metadata;

  const filterToIcon: Partial<Record<PatientKind | BrowseAllPatientKind, IconDefinition>> = {
    [PatientKind.Canine]: faDog,
    [PatientKind.Feline]: faCat,
    [PatientKind.Equine]: faHorse,
  };

  const filterToDisplayName: Partial<Record<PatientKind | BrowseAllPatientKind, string>> = {
    [PatientKind.Canine]: "Dogs",
    [PatientKind.Feline]: "Cats",
    [PatientKind.Equine]: "Horses",
    [BrowseAllPatientKind.ALL]: "All Pets",
  };

  // default to hard coded cat/dog filters if the clinic doesn't have a ClinicMetadata set up
  const filterOptions: (PatientKind | BrowseAllPatientKind)[] = clinicMetadata
    ? [
        ...(clinicMetadata.is_canine_filter_enabled ? [PatientKind.Canine] : []),
        ...(clinicMetadata.is_feline_filter_enabled ? [PatientKind.Feline] : []),
        ...(clinicMetadata.is_equine_filter_enabled ? [PatientKind.Equine] : []),
      ]
    : [PatientKind.Canine, PatientKind.Feline];

  if (filterOptions.length > 1) {
    filterOptions.unshift(BrowseAllPatientKind.ALL);
  }

  return (
    <>
      {/* If the clinic has a specialty designation, they won't need any filters
      since they are mainly treating one species */}
      {!clinicMetadata?.specialty_designation && (
        <div className={styles.filters}>
          <InlineSelect<IBrowseFilterSpeciesKind> value={species} onChange={setSpecies}>
            {filterOptions.map((filter) => (
              <InlineSelect.Option key={filter} value={filter}>
                {filterToIcon[filter] && <Icon icon={filterToIcon[filter] as IconDefinition} />}{" "}
                {filterToDisplayName[filter] && filterToDisplayName[filter]}
              </InlineSelect.Option>
            ))}
          </InlineSelect>
        </div>
      )}
    </>
  );
};

export default CatalogFilters;
